import i18next from 'i18next';

import EntityFactory from '../factory/famly-app';
import SessionVersionsEntity from '../session-versions/index';
import ProductVersionsEntity from '../product-versions/index';
import ChildPlanBehaviorsEntity from './child-plans-behaviors-entity';
import PlanEntity from './model';

const AnySessionVersionsEntity = SessionVersionsEntity as any;

export default EntityFactory.createEntity({
    domain: 'ENTITIES/PLANS',
    entityName: i18next.t('entities.names.plan'),
    model: PlanEntity,
    groupByKeys: ['childId'],
    entityRelations: [
        {
            entity: AnySessionVersionsEntity,
            responseHandlers: {
                fetchAll: response => response.sessions,
            },
        },
        {
            entity: ProductVersionsEntity as MadeAnyDuringTs45Update,
            responseHandlers: {
                fetchAll: response => response.products,
            },
        },
        {
            entity: ChildPlanBehaviorsEntity as MadeAnyDuringTs45Update,
            responseHandlers: {
                fetchAll: (response, originalPayload) => [
                    {
                        behaviors: response.behaviors,
                        id:
                            originalPayload.childIds && originalPayload.institutionId
                                ? originalPayload.institutionId
                                : originalPayload.id,
                    },
                ],
            },
        },
    ],
    apiDescription: {
        fetchAll: {
            url: payload => (payload.childIds ? 'v2/plans/list?version=2' : 'v2/plans/?version=2'),
            requestMethod: payload => (payload.childIds ? 'POST' : undefined),
            requestPayload: payload =>
                payload.childIds
                    ? {
                          childIds: payload.childIds,
                          includeVersionData: true,
                          onlyCurrentAndFuture: payload.onlyCurrentAndFuture,
                      }
                    : {childId: payload.id, flexiblePackages: true},
            locateResponse: response => response.plans,
        },
        create: {
            url: () => `v2/plans?preview=${false}&version=2`,
        },
        update: {
            url: payload => `v2/plans/${payload.id}?version=2`,
        },
        delete: {
            url: payload => `v2/plans/${payload.id}?version=2`,
        },
    },
});
